<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('FORMS.SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        small
        class="mr-2"
        color="error"
        @click="promoteForms()"
        :disabled="allHqConns.length == 0"
      >{{ $t('FORMS.BTNS.PROMOTE') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="warning"
        @click="importForm()"
      >{{ $t('FORMS.BTNS.IMPORT') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="success"
        @click="buildForm()"
      >{{ $t('FORMS.BTNS.NEW') }}</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="allForms"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="ID"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn
          v-if="row.item.IS_LOCKED == 1"
          small
          class="mr-2"
          color="warning"
          @click="showLocked(row.item)"
        >
          <v-icon small>mdi-lock</v-icon>
        </v-btn>
        <v-btn
          v-if="row.item.IS_DEPLOYED == 1 || row.item.IS_LOCKED == 1"
          small
          class="mr-2"
          color="success"
          @click="viewForm(row.item)"
        >
          {{ $t('GENERAL.BTNS.VIEW') }}
        </v-btn>
        <v-btn
          v-if="row.item.IS_DEPLOYED == 0 && row.item.IS_LOCKED == 0"
          small
          class="mr-2"
          color="warning"
          @click="editForm(row.item)"
        >
          {{ $t('GENERAL.BTNS.EDIT') }}
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="secondary"
          @click="copyForm(row.item)"
        >
          {{ $t('GENERAL.BTNS.COPY') }}
        </v-btn>
        <v-btn
          v-if="row.item.IS_DEPLOYED == 0 && row.item.IS_LOCKED == 0"
          small
          class="mr-2"
          color="error"
          @click="deleteForm(row.item)"
        >
          {{ $t('GENERAL.BTNS.DELETE') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="deleteDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDelete({formId})"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="importFormDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ importTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ importText }}</div>
            <v-file-input
              v-model="importedFile"
              :label="$t('FORMS.IMPORT_FORM.FIELDS.FILE_LABEL')"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelImportForm()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmImportForm()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteFormsDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteFormsTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ promoteFormsText }}</div>
            <v-data-table
              v-model="formPromote"
              :headers="promoteHeaders"
              :items="allForms"
              :items-per-page="10"
              class="mx-3 mb-3"
              item-key="ID"
              sort-by="ID"
              :sort-desc="true"
              show-select
              loading-text="Loading... Please wait"
              :loading="loading"
            >
            </v-data-table>
            <v-form v-model="isFormValid" ref="promoteForm">
              <v-select
                v-model="selectedExternalEngine"
                :label="$t('FORMS.PROMOTE.FIELDS.ENGINE')"
                :items="allHqConns"
                item-text="ENGINE_NAME"
                item-value="URL"
                :rules="[rules.required]"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelPromote()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmPromoteForms()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteCheckDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteCheckTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ promoteCheckText }}</div>
            <div class="pt-5" v-html="promoteCheckText2"></div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              class="mr-2"
              color="secondary"
              @click="promoteCheckCancel"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="promoteOverwrite > 0 && promoteCount > 0"
              small
              class="mr-2"
              color="warning"
              @click="promoteCheckConfirm"
            >{{ $t('FORMS.BTNS.NO_OVERWRITE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="promoteOverwrite > 0"
              small
              class="mr-2"
              color="error"
              @click="promoteCheckOverwrite"
            >{{ $t('FORMS.BTNS.OVERWRITE') }}</v-btn>
            <v-btn
              v-if="promoteOverwrite == 0 && promoteCount > 0"
              small
              class="mr-2"
              color="success"
              @click="promoteCheckConfirm"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteResultsDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteResultsTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5" v-html="promoteResultsText"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="promoteResultsDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="showLockedDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ lockedTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ lockedText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              color="warning"
              @click="forceUnlock()"
            >{{ $t('FORMS.BTNS.FORCE_UNLOCK') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="showLockedDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="showDeployedDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deployedTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deployedText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="showDeployedDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  export default {
    name: 'formbuilder',
    computed: {
      ...mapGetters(['allForms', 'formDeployed', 'formLocked', 'formLockedUser', 'allHqConns', 'promoteFormData', 'promoteFormRes'])
    },
    data: function() {
      return {
        loading: false,
        isFormValid: false,
        rules: {
          required: value => !!value || 'Required'
        },
        deleteDialog: false,
        deleteTitle: '',
        deleteText: '',
        importFormDialog: false,
        importTitle: '',
        importText: '',
        importedFile: null,
        showLockedDialog: false,
        lockedFormId: '',
        lockedTitle: '',
        lockedText: '',
        showDeployedDialog: false,
        deployedTitle: '',
        deployedText: '',
        theFormTitle: '',
        formId: '',
        search: '',
        promoteFormsDialog: false,
        promoteFormsTitle: '',
        promoteFormsText: '',
        promoteCheckDialog: false,
        promoteCheckTitle: '',
        promoteCheckText: '',
        promoteCheckText2: '',
        promoteCount: 0,
        promoteOverwrite: 0,
        promoteResultsDialog: false,
        promoteResultsTitle: '',
        promoteResultsText: '',
        formPromote: [],
        selectedExternalEngine: '',
        sortBy: '',
        sortDesc: false,
        rowsPerPage: 25,
        headers: [
          {
            text: this.$t('FORMS.FIELDS.ID'),
            align: 'start',
            sortable: true,
            value: 'ID'
          },
          { text: this.$t('FORMS.FIELDS.TITLE'), sortable: true, value: 'FORM_TITLE' },
          { text: this.$t('FORMS.FIELDS.FORM_KEY'), value: 'FORM_KEY' },
          { text: this.$t('PROCESSES.FIELDS.PROCESS_NAME'), value: 'PROCESS_NAME' },
          { text: this.$t('FORMS.FIELDS.PROCESS_KEY'), value: 'PROCESS_KEY' },
          { text: this.$t('FORMS.FIELDS.PROCESS_VERSION'), value: 'PROCESS_VERSION' },
          { text: this.$t('FORMS.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        promoteHeaders: [
          { text: this.$t('FORMS.FIELDS.ID'), align: 'start', value: 'ID' },
          { text: this.$t('FORMS.FIELDS.TITLE'), value: 'FORM_TITLE' },
          { text: this.$t('FORMS.FIELDS.PROCESS_KEY'), value: 'PROCESS_KEY', sortable: false },
          { text: this.$t('FORMS.FIELDS.PROCESS_VERSION'), value: 'PROCESS_VERSION', sortable: false }
        ],
        snack: false,
        snackColor: '',
        snackText: ''
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'IMPORT_FORM_SAVED') {
          this.refreshForms();
        }

        if(mutation.type === 'PROMOTE_FORM_DATA') {
          this.promoteCount = 0;
          this.promoteOverwrite = 0;
          let html = '';
          let formExists = false;
          
          for(let i = 0; i < this.formPromote.length; i++) {
            formExists = false;
            for(let j = 0; j < this.promoteFormData.length; j++) {
              if(this.formPromote[i].FORM_KEY == this.promoteFormData[j].FORM_KEY) {
                formExists = true;
                if(this.promoteFormData[j].IS_LOCKED) {
                  html += '<p class="red--text font-weight-bold">' + this.$t('FORMS.PROMOTE.FORM') + ' <em>' + this.formPromote[i].FORM_TITLE + ' (' + this.formPromote[i].FORM_KEY + ')' + '</em> ' + this.$t('FORMS.PROMOTE.LOCKED') + '</p>';
                }else if(this.promoteFormData[j].IS_DEPLOYED) {
                  html += '<p class="red--text font-weight-bold">' + this.$t('FORMS.PROMOTE.FORM') + ' <em>' + this.formPromote[i].FORM_TITLE + ' (' + this.formPromote[i].FORM_KEY + ')' + '</em> ' + this.$t('FORMS.PROMOTE.DEPLOYED') + '</p>';
                }else {
                  this.promoteOverwrite++;
                  html += '<p class="orange--text font-weight-bold">' + this.$t('FORMS.PROMOTE.FORM') + ' <em>' + this.formPromote[i].FORM_TITLE + ' (' + this.formPromote[i].FORM_KEY + ')' + '</em> ' + this.$t('FORMS.PROMOTE.EXISTS') + '</p>';
                }
              }
            }

            if(!formExists) {
              this.promoteCount++;
              html += '<p class="green--text font-weight-bold">' + this.$t('FORMS.PROMOTE.FORM') + ' <em>' + this.formPromote[i].FORM_TITLE + ' (' + this.formPromote[i].FORM_KEY + ')' + '</em> ' + this.$t('FORMS.PROMOTE.CREATED') + '</p>';
            }
          }

          if(this.formPromote.length == 0) {
            html = '<p>' + this.$t('FORMS.PROMOTE.NONE') + '</p>';
          }

          this.promoteCheckTitle = this.$t('FORMS.PROMOTE.CHECK_TITLE');
          this.promoteCheckText = this.$t('FORMS.PROMOTE.CHECK_DESC');
          this.promoteCheckText2 = html;
          this.promoteCheckDialog = true;
        }

        if(mutation.type === 'PROMOTE_FORM_RES') {
          let html = '';
          let formNames = [];

          for(let i = 0; i < this.promoteFormRes.length; i++) {
            const formKeys = Object.keys(this.promoteFormRes[i]);
    
            formKeys.forEach((key) => {
              if(this.promoteFormRes[i][key] == 'insert') {
                html += '<p>' + this.$t('FORMS.PROMOTE.FORM') + ' ' + key + ' ' + this.$t('FORMS.PROMOTE.INSERT_SUCCESS') + '</p>';
              }
              if(this.promoteFormRes[i][key] == 'update') {
                html += '<p>' + this.$t('FORMS.PROMOTE.FORM') + ' ' + key + ' ' + this.$t('FORMS.PROMOTE.UPDATE_SUCCESS') + '</p>';
              }
              formNames.push(key);
            });
          }

          if(formNames.length > 0) {
            this.updateLog('Forms', 'Promoted', 'Forms ' + formNames.toString() + ' promoted to ' + this.selectedExternalEngine + '.');
          }

          this.promoteResultsTitle = this.$t('FORMS.PROMOTE.RESULT_TITLE');
          this.promoteResultsText = html;
          this.promoteResultsDialog = true;
          this.$refs.promoteForm.reset();
          this.formPromote = [];
        }

      });
      this.$store.dispatch('getAllHqConnections');
      this.refreshForms();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    mounted() {
      let ref = this;
      $(function() {
        // Page options listener
        let el = document.querySelector('div[aria-haspopup="listbox"]');
        el.addEventListener('click', function() {
          let pageOptions = document.querySelectorAll('div[role="option"]');

          pageOptions.forEach(function(option) {
            option.addEventListener('click', function() {
              let rows = document.querySelector('.v-select__selection.v-select__selection--comma');
              ref.rowsPerPage = rows.innerHTML;
            });
          });
        });
      });
    },
    methods: {
      refreshForms() {
        this.loading = true;
        this.$store.dispatch('getAllForms').then( () => {
          this.loading = false;
          // Apply sort field and order
          let field = this.$store.state.formBuilderSortField;
          let sort = this.$store.state.formBuilderSortOrder;
          if(field == null) {
            this.sortBy = 'ID';
            this.sortDesc = true;
          }else if (sort == 'none') {
            this.sortBy = '';
            this.sortDesc = false;
          }else {
            this.sortBy = field;

            if(sort == 'descending') {
              this.sortDesc = true;
            }else {
              this.sortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.headers.length; i++) {
              if(column == ref.headers[i].text) {
                ref.$store.commit('setFormBuilderSortField', ref.headers[i].value);
                ref.$store.commit('setFormBuilderSortOrder', order);
              }
            }
          });
        });
      },
      buildForm() {
        this.$store.commit('UPDATE_PROCESS_KEY', '');
        this.$store.commit('UPDATE_PROCESS_VERSION', null);
        this.$store.commit('UPDATE_FORM_KEY', '');
        this.$store.commit('FORM_TITLE', 'My New Form');
        this.$store.commit('UPDATE_FORM_ID', 0);
        this.$store.commit('UPDATE_FORM_ACTION', 'new');
        this.$router.push({ name: 'BuildForm' });
      },
      editForm(item) {
        let payload = {
          'formId': item.ID,
          'checkType': 'single'
        };
        this.$store.dispatch('lockCheck', payload).then(() => {
          if(this.formLocked) {
            this.showLocked(this.formLockedUser);
            this.refreshForms();
          }else if(this.formDeployed) {
            this.showDeployed();
            this.refreshForms();
          }else {
            this.$store.commit('UPDATE_PROCESS_KEY', item.PROCESS_KEY);
            this.$store.commit('UPDATE_PROCESS_VERSION', item.PROCESS_VERSION);
            this.$store.commit('UPDATE_FORM_KEY', item.FORM_KEY);
            this.$store.commit('UPDATE_FORM_ID', item.ID);
            this.$store.commit('UPDATE_FORM_ACTION', 'edit');
            this.$store.commit('EDITING_FORM', true);
            this.$router.push({ name: 'BuildForm' });
          }
        });
      },
      copyForm(item) {
        // Set new form ID
        let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let newFormKey = 'Form_';

        // Generate ID
        for (let j = 0; j < 7; j++) {
            newFormKey += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        let payload = {
          'formId': item.ID,
          'newFormKey': newFormKey
        }
        this.$store.dispatch('copyForm', payload).then( () => {
          this.updateLog('Form', 'Copied', 'Form ' + item.FORM_TITLE + ' duplicated.');

          this.refreshForms();
        });
      },
      viewForm(item) {
        this.$store.commit('UPDATE_PROCESS_KEY', item.PROCESS_KEY);
        this.$store.commit('UPDATE_PROCESS_VERSION', item.PROCESS_VERSION);
        this.$store.commit('UPDATE_FORM_KEY', item.FORM_KEY);
        this.$store.commit('UPDATE_FORM_ID', item.ID);
        this.$store.commit('UPDATE_FORM_ACTION', 'view');
        this.$router.push({ name: 'BuildForm' });
      },
      deleteForm(item) {
        let payload = {
          'formId': item.ID,
          'checkType': 'single'
        };
        this.$store.dispatch('lockCheck', payload).then(() => {
          if(this.formLocked) {
            this.showLocked(this.formLockedUser);
            this.refreshForms();
          }else if(this.formDeployed) {
            this.showDeployed();
            this.refreshForms();
          }else {
            this.deleteTitle = this.$t('FORMS.DELETE_FORM.TITLE');
            this.deleteText = this.$t('FORMS.DELETE_FORM.DESC') + ' ' + item.FORM_TITLE + ' (' + item.FORM_KEY + ')';
            this.theFormTitle = item.FORM_TITLE;
            this.formId = item.ID;
            this.deleteDialog = true;
          }
        });
      },
      confirmDelete(item) {
        this.deleteDialog = false;
        let payload = {
          'formId': item.formId
        }
        this.$store.dispatch('deleteForm', payload).then( () => {
          this.updateLog('Form', 'Deleted', 'Form ' + this.theFormTitle + ' deleted.');

          this.refreshForms();
          this.snackDelete();
        });
      },
      readFile(file, callback) {
        var reader = new FileReader();
        reader.onloadend = callback;
        reader.readAsText(file);
      },
      cancelImportForm() {
        this.importFormDialog = false;
        this.importedFile = null;
      },
      importForm() {
        this.importTitle = this.$t('FORMS.IMPORT_FORM.TITLE');
        this.importText = this.$t('FORMS.IMPORT_FORM.DESC');
        this.importFormDialog = true;
      },
      confirmImportForm() {
        let fileInfo = this.importedFile.name.split('.');
        
        if(fileInfo[1] != 'frm') {
          this.snackImportError();
        }else {
          this.importFormDialog = false;

          let ref = this;
          this.readFile(this.importedFile, function(reader) {
            let fileData = JSON.parse(reader.target.result);
            let isMulti = 0;
            if(fileData[0].IS_MULTI) {
              isMulti = 1;
            }
            
            let payload = {
              'processKey': fileData[0].PROCESS_KEY,
              'processVersion': fileData[0].PROCESS_VERSION,
              'formKey': fileData[0].FORM_KEY,
              'formTitle': fileData[0].FORM_TITLE,
              'schema': fileData[0].FORM_CONTENT,
              'gridLayout': fileData[0].GRID_LAYOUT,
              'extScript': fileData[0].EXT_SCRIPT,
              'isMulti': isMulti,
              'isDeployed': 0,
              'isLocked': 0,
              'sqlQueries': fileData[0].SQL_QUERIES
            };
            ref.$store.dispatch('importForm', payload).then( () => {
              ref.updateLog('Form', 'Imported', 'Form ' + fileData[0].FORM_TITLE + ' imported.');

              ref.importedFile = null;
            });
          });
        }
      },
      cancelPromote() {
        this.promoteFormsDialog = false;
        this.$refs.promoteForm.reset();
        this.formPromote = [];
      },
      promoteForms() {
        this.promoteFormsTitle = this.$t('FORMS.PROMOTE.TITLE');
        this.promoteFormsText = this.$t('FORMS.PROMOTE.DESC');
        this.promoteFormsDialog = true;
      },
      confirmPromoteForms() {
        this.promoteFormsDialog = false;
        let promotePayload = [];
        let formNames = [];

        for(let i = 0; i < this.formPromote.length; i++) {
          promotePayload.push({ formName: this.formPromote[i].FORM_TITLE, formId: this.formPromote[i].ID, formKey: this.formPromote[i].FORM_KEY });
          formNames.push(this.formPromote[i].FORM_TITLE);
        }
        
        let payload = {
          promotes: JSON.stringify(promotePayload),
          engine: this.selectedExternalEngine
        };
        
        this.$store.dispatch('promoteFormsCheck', payload);
      },
      promoteCheckCancel() {
        this.promoteCheckDialog = false;
        this.$refs.promoteForm.reset();
        this.formPromote = [];
      },
      promoteCheckConfirm() {
        this.promoteCheckDialog = false;
        
        for(let i = 0; i < this.formPromote.length; i++) {
          for(let j = 0; j < this.promoteFormData.length; j++) {
            if(this.formPromote[i].FORM_KEY == this.promoteFormData[j].FORM_KEY) {
              this.formPromote.splice(i, 1);
            }
          }
        }
        
        let payload = {
          promotes: JSON.stringify(this.formPromote),
          engine: this.selectedExternalEngine
        };
        
        this.$store.dispatch('promoteForms', payload);
      },
      promoteCheckOverwrite() {
        this.promoteCheckDialog = false;
        
        for(let i = 0; i < this.formPromote.length; i++) {
          for(let j = 0; j < this.promoteFormData.length; j++) {
            if(this.formPromote[i].FORM_KEY == this.promoteFormData[j].FORM_KEY) {
              if(this.promoteFormData[j].IS_LOCKED || this.promoteFormData[j].IS_DEPLOYED) {
                this.formPromote.splice(i, 1);
              }
            }
          }
        }

        let payload = {
          promotes: JSON.stringify(this.formPromote),
          engine: this.selectedExternalEngine
        };
        
        this.$store.dispatch('promoteForms', payload);
      },
      forceUnlock() {
        this.$store.commit('EDITING_FORM', false);
        let payload = {
          'formId': this.lockedFormId,
          'checkType': 'unlock'
        };
        this.$store.dispatch('lockCheck', payload).then( () => {
          this.showLockedDialog = false;
          this.refreshForms();
        });
      },
      showLocked(item) {
        let user = item.LOCKED_BY;
        this.lockedFormId = item.ID;
        this.lockedTitle = this.$t('FORMS.LOCKED.TITLE');
        this.lockedText = this.$t('FORMS.LOCKED.DESC') + ' ' + user + '.';
        this.showLockedDialog = true;
      },
      showDeployed() {
        this.deployedTitle = this.$t('FORMS.DEPLOYED.TITLE');
        this.deployedText = this.$t('FORMS.DEPLOYED.DESC');
        this.showDeployedDialog = true;
      },
      snackDelete () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Form deleted successfully.'
      },
      snackImportError () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Incorrect file type. Please upload an FRM file.'
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>
